// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"997407d0","239":"cf961b85","316":"325e865f","389":"1c32c4b1","453":"926963ec","669":"19f46af8","732":"6eda1f97","857":"4b7c5849","970":"08ed157c"}[chunkId] + ".chunk.js";
};